const routes = {
  rates: 'Preise',
  parents: 'Eltern',
  newScenario: 'Neues Szenario',
  viewSites: 'Bereiche anzeigen',
  sites: 'Bereiche',
  attributes: 'Eigenschaften',
  suppliers: 'Anbieter',
  updateSupplier: 'Anbieter aktualisieren',
  createSupplier: 'Anbieter anlegen',
  shuttles: 'Shuttlebusse',
  updateShuttle: 'Shuttle aktualisieren',
  createShuttle: 'Shuttles erstellen',
  fares: 'Tarife',
  updateFare: 'Tarif aktualisieren',
  createFare: 'Tarif erstellen',
  services: 'Leistungen',
  updateService: 'Dienst aktualisieren',
  createService: 'Dienst erstellen',
  users: 'Benutzer',
  updateUser: 'Benutzer aktualisieren',
  createUser: 'Benutzer erstellen',
  vehicles: 'Fahrzeuge',
  updateVehicle: 'Fahrzeug aktualisieren',
  createVehicle: 'Fahrzeug erstellen',
  areas: 'Zonen',
  updateArea: 'Aktualisierungsbereich',
  createArea: 'Bereich erstellen',
  drivers: 'Fahrer',
  updateDriver: 'Fahrer aktualisieren',
  createDriver: 'Fahrer erstellen',
  playground: 'Spielplatz',
  support: 'Support',
  parameters: 'Parameter',
  createParameter: 'Parameter erstellen',
  analytics: 'Analyse',
  settings: 'Einstellungen',
  liveMap: 'Live-Karte',
  driverShifts: 'Fahrerschichten',
  createDriverShift: 'Erstellen einer einzelnen Fahrerschicht',
  createMultipleDriverShifts: 'Erstellen mehrerer Fahrerschichten',
  passengers: 'Fahrgäste',
  students: 'Schüler',
  employees: 'Mitarbeiter',
  editShuttle: 'Shuttle bearbeiten',
  updatePassenger: 'Fahrgast bearbeiten',
  createPassenger: 'Neuer Fahrgast',
  onlineDrivers: 'Online Fahrer',
  trips: 'Fahrten',
  productionTrips: 'Produktionsfahrten',
  reservations: 'Buchungen',
  editReservation: 'Buchung bearbeiten',
  createReservation: 'Buchung erstellen',
  createQuick: 'Schnell erstellen',
  timeline: 'Zeitleiste',
  home: 'Missionskontrolle',
  import: 'Daten hochladen',
  reports: 'Berichte',
  shuttleReports: 'Shuttle-Berichte',
  locations: 'Standorte',
  createLocation: 'Standort erstellen',
  editLocation: 'Standort aktualisieren',
  profiles: 'Profil',
  shifts: 'Schichten',
  createShift: 'Schicht erstellen',
  updateShift: 'Schicht aktualisieren',
  agentHome: 'Agent',
  createExtraService: 'Extra Dienst erstellen',
  updateExtraService: 'Extra Dienst aktualisieren',
  extraServices: 'Zusatzleistungen',
  tripsPaxReports: 'Fahrten-/ Fahrgast-Übersicht',
  uniqueDriversReport: 'Einzigartige Fahrer pro Tag',
  permissions: 'Rollen und Berechtigungen',
  createJob: 'Reservierung erstellen',
  quickJob: 'Schnelle Reservierung',
  onboarding: 'Szenario-Generator - NEMT',
  holidays: 'Feiertage',
  blacklist: 'Karten-Blacklist',
  integrations: 'Integrationen',
  automations: 'Automatisierungen',
  jobsCalendar: 'Buchungskalender',
  caregivers: 'Pflegekräfte',
  customRules: 'Benutzerdefinierte Regeln',
  billReports: 'Rechnungsberichte',
  performanceOverview: 'Leistungsübersicht',
  facilities: 'Einrichtungen',
  roiSimulation: 'ROI-Simulation',
};

export default routes;
